module.exports = __webpack_public_path__ + "static/img/rm_brand_img_yumeigui_details.4014865.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_yumeigui_details.png
// module id = nJJK
// module chunks = 1